@use '@/styles/tokens' as *;
@use '@/styles/popup' as *;

.select {
  min-width: 0;

  :global(.ant-select-selector) {
    border-radius: 10px;
  }

  &:hover:not(:global(.ant-select-disabled)) :global(.ant-select-selector) {
    box-shadow: var(--shadow-field-hover);
  }

  :global(.ant-select-selection-placeholder) {
    color: var(--overlay-20);
  }
}

.compact :global(.ant-select-selector) {
  height: 36px;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 18px;
  max-width: 200px;
  margin-inline-end: 6px;
  padding: 0 8px;
  border-radius: 24px;
  background: $color-neutral-100;
  font-size: 12px;
  color: var(--text-primary);
  white-space: nowrap;
}

// A long selected label truncates rather than pushing the tag past the field's edge (114805);
// `select.tsx` gives it a native `title` so the full name is still available on hover.
.tagLabel {
  min-width: 0;
  overflow: hidden;
  line-height: 1;
  text-overflow: ellipsis;
}

.tagRemove {
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  color: var(--text-primary);
  cursor: pointer;
}

.popup {
  @include popup-chrome;

  :global(.ant-select-item-option) {
    @include popup-item;
  }

  :global(.ant-select-item-option-selected) {
    background: $color-neutral-100;
  }
}

// Opt-in empty state (Figma 216:264119) — muted glyph above a centred message. Sits inside the
// shared popup shell, so it draws no card of its own (see plan.md deviation D1).
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-16) var(--space-4);
  font-size: $font-size-xs;
  color: var(--text-tertiary);
  text-align: center;
}

.emptyIcon {
  color: var(--text-secondary);
  opacity: 0.3;
}
